module.exports = __webpack_public_path__ + "img/log.2ce8542e.svg";